<dx-popup
  id="dialog-ajout-association-produit-complementaire"
  width="92vw"
  height="88vh"
  [resizeEnabled]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [showCloseButton]="false"
  [wrapperAttr]="{ class: 'produit-complementaire-ajout-association-popup' }"
  (onShowing)="onShowing()"
  [(visible)]="visible">

  <div *dxTemplate="let _ of 'title'" class="produit-complementaire-ajout-association-header">
    <div>
      <yo-icon icon="plus"></yo-icon> <strong> Associer des points de livraison</strong>
    </div>

    <div class="produit-complementaire-ajout-association-header-actions">
      <yo-button
        iconClass="fas fa-save"
        tooltip="Enregistrer les associations"
        [theme]="ButtonThemeEnum.SAVE"
        [disabled]="!propositionList().length"
        (onClick)="ajouter()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Annuler"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="fermer()">
      </yo-button>
    </div>
  </div>

  <section class="produit-complementaire-ajout-association-content">
    <div class="produit-complementaire-ajout-association-barre-outils">
      <div class="produit-complementaire-ajout-association-declinaison">
        <span>Produit décliné</span>
        <yo-lookup
          [data]="produitDeclinaisonList()"
          [selectedItem]="produitDeclinaisonId()"
          [displayValue]="getProduitDeclinaisonLibelle"
          [width]="320"
          placeholder="Sélectionner un produit décliné ..."
          (onValueChange)="onProduitDeclinaisonChange($event)">
        </yo-lookup>

        <yo-button
          iconClass="fas fa-plus"
          [theme]="ButtonThemeEnum.ADD"
          label="Choisir des points de livraison"
          (onClick)="openSelection()">
        </yo-button>
      </div>

      <span class="produit-complementaire-compteur">{{ propositionList().length }} association(s) à paramétrer</span>
    </div>

    <yo-produit-complementaire-grid
      [produitComplementaireList]="propositionList()"
      [keyExpr]="KEY_EXPR"
      [plcColonneVisible]="true"
      [pagingInterne]="true"
      noDataText="Choisissez un produit décliné puis ses points de livraison pour composer votre proposition"
      suppressionIconClass="fas fa-times"
      suppressionTooltip="Retirer de la proposition"
      (periodeClick)="openDialogPeriode($event)"
      (suppressionClick)="retirerDeLaProposition($event)"
      (jourClick)="toggleJour($event)">
    </yo-produit-complementaire-grid>
  </section>
</dx-popup>

<yo-dialog-selection-plc
  [(visible)]="selectionVisible"
  [produitDeclinaisonId]="produitDeclinaisonId()"
  [produitLibelle]="produitDeclinaisonLibelle()"
  [selectedPlcIdList]="selectedPlcIdList()"
  (selectionValidee)="onSelectionValidee($event)">
</yo-dialog-selection-plc>

<yo-dialog-periode-conditionnement
  [(visible)]="dialogPeriodeVisible"
  [produit]="produitPeriode()"
  (periodeListChange)="onPeriodeListChange($event)">
</yo-dialog-periode-conditionnement>
